export const enum PlusPaymentPlace {
    PaywallBaseOfferButton = 'PaywallBaseOfferButton',
    PaywallExtraOfferButton = 'PaywallExtraOfferButton',
    PaywallPlusOfferButton = 'PaywallPlusOfferButton',
    PaywallExtraPlusOfferButton = 'PaywallExtraPlusOfferButton',
    AcceptButton = 'AcceptButton',
    ChannelPaywall = 'ChannelPaywall',
    ChannelsPaywall = 'ChannelsPaywall',
    Header = 'Header',
    MoviePreview = 'MoviePreview',
    NoAuthMainOffer = 'NoAuthMainOffer',
    PaywallMain = 'PaywallMain',
    SerialStructure = 'SerialStructure',
    WatchButton = 'WatchButton',
    CrunchyrollPaywall = 'CrunchyrollPaywall',
    MustWatch = 'MustWatch',
    PaywallCounterOffer = 'PaywallCounterOffer',
    PaywallCounterOfferReference = 'PaywallCounterOfferReference',
    Purchases = 'Purchases',
    SportChannelPaywall = 'SportChannelPaywall',
    SportPromoWatchButton = 'SportPromoWatchButton',
}
